import { Injectable } from '@angular/core';
import { SharedHttpService } from './shared-http.service';
import * as moment from 'moment';
import { CaseService } from './case.service';

@Injectable({
    providedIn: 'root'
})

export class CriminalReportService {

    reportData: any;
    ecaseid: any;
    caseSourceId: any;

    constructor(public caseService: CaseService, private sharedService: SharedHttpService) { }

    convertNumerals(input: string) {
        if (input == null)
            return "";
        else
        return input.toString().split('0').join('٠')
            .split('1').join('١')
            .split('2').join('٢')
            .split('3').join('٣')
            .split('4').join('٤')
            .split('5').join('٥')
            .split('6').join('٦')
            .split('7').join('٧')
            .split('8').join('٨')
            .split('9').join('٩');
    }
    transformToDateOnly(value: string): string {
        if (value != null && value.trim() != "") {
            let ret = "";
            ret = moment(value).format('DD-MM-YYYY');

            return ret;
        }
        return "";
    }
    printReport(caseId) {
        this.caseSourceId = this.caseService.case.caseSourceId;
        if (this.caseSourceId == 15) {
            //متابعة
            this.sharedService.get(`api/Case/GetCriminalReport?CaseId=${caseId}`).subscribe(result => {
                this.reportData = result;
                let violations = '';
                let evidences = '';
                let criminalNumber = '';
                let report = '';
                let record = '';
                let actionTaken = '';
                let reportNotes = '';
                let criminalPersonName = '';
                let branchManagerName = '';
                let qualityName = '';
                let daysNumber = '';
                let returnNumber = '';
                let employeeSign = '';
                let members = '';
                let plaintiffsMembers=''

                let fullName = this.sharedService.CurrentUser.fullName;
                let currentDateTime = moment((new Date)).format('DD/MM/YYYY - h:mm');
                this.ecaseid = this.caseService.case.eCaseId;

                this.reportData.violations.map((el,) => {
                    violations = violations.concat(`<p> - ${this.convertNumerals(el.mainViolationTypeName)}</p>`);
                });

                if (this.reportData.evidencesText != '') {
                    evidences = evidences.concat(`<p >رابعاً: الادلة والقرائن: </p>`)

                    if (this.reportData.evidencesText == null) {
                        evidences = evidences + '----';
                    }
                    else evidences = evidences + `<p style="padding-right: 79px;">${this.convertNumerals(this.reportData.evidencesText)}</p>  <hr/>`;

                }
               
                if (this.reportData.criminalNumber == null) {
                    let getUrl = `api/Case/CreateOrEditCriminalNumber?IsAuto=true&eCaseId=${this.ecaseid}`;
                    this.sharedService.get(getUrl).subscribe((res) => {
                        criminalNumber = criminalNumber.concat(`${this.convertNumerals(res.message)}`);
                    });
                }
                if (this.reportData.criminalNumber != null) {
                    criminalNumber = criminalNumber.concat(`${this.convertNumerals(this.reportData.criminalNumber)}`);
                }
                if (this.reportData.callRecords != null) {
                    this.reportData.callRecords.map((el,i) => {
                        record = record.concat(`<p style="padding-right: 79px;">- تم سماع أقوال المشتبه بهم بتاريخ  ${this.convertNumerals(this.transformToDateOnly(el.createdOn))}</p>`);
                        if(i === this.reportData.callRecords.length -1){
                            record = record.concat(`<hr/>`)
                        }
                    });
                }
                if (this.reportData.actionTaken != null) {
                    actionTaken = actionTaken.concat(`<p style="padding-right: 79px;"> - بناء على ذلك تـم : ${this.reportData.actionTaken}  </p><hr/>`);
                }
                if (this.reportData.reportNotes != null) {
                    reportNotes = reportNotes.concat(`
                    <p >ثالثاً: الدراسة:</p>
                    <p style="padding-right: 79px;">بدراسـة الموضوع ومـا تضمنتـه الإجـراءات المتخذة يتضـح الآتي:</p>${this.reportData.lakeOfDataName ? this.reportData.lakeOfDataName : ' '}
                    <p style="padding-right: 79px;">${this.convertNumerals(this.reportData.reportNotes)}</p>
                    <hr/>
                    `);
                    if (this.reportData.penalities != null) {
                        this.reportData.penalities.map((el,i) => {
                            reportNotes = reportNotes + "<p>" + el.companyPenaltyTypeName + "</p>";
                            if(i === this.reportData.penalities - 1 ){
                                reportNotes = reportNotes.concat(`<hr/>`)
                            }
                        });
                    }
                }

                this.reportData.reports.map(el => {
                    if (el.reportNumber == null && el.reporterNationalId == null && el.reporterName == null && el.reporterRelationName == "") {
                        report = report.concat(`
                        <p >ثانياً: الوقائع: </p>
                        <p style="padding-right: 79px;"> هوية وطنية/الإقامة رقم----
                            بصفته  ---- </p>
                        <hr/>
                        `);
                    }
                    report = report.concat(`
                    <p >ثانياً: الوقائع: </p>
                    <p style="padding-right: 79px;"> بناء على الدور الرقابي والاشرافي في ضبط مخالفات نظام الشركات فقد تبين    </p>
                    `);
              
                });
                let isOffenderExist=false;

                if (this.reportData.members != null) {
                    this.reportData.members.map((el,i) => {
                        if (el.memberTypeId && el.memberTypeId == 5) {
                            members = members.concat(` <p style="padding-right: 79px;"> - الاشتباه بالمخالفة ضد هوية وطنية/الإقامة رقم ${this.convertNumerals(el.nationIdOrIqama)}  ${el.name} بصفته ${el.memberTypeName}</p>`);
                        }
                        if (el.memberTypeId && el.memberTypeId == 6) {
                            isOffenderExist=true;
                            plaintiffsMembers = plaintiffsMembers.concat(`<p style="padding-right: 79px;"> - هوية وطنية/الإقامة رقم ${this.convertNumerals(el.nationIdOrIqama)}  ${el.name} بصفته ${el.memberTypeName}</p>`);
                        }
                        if(i=== this.reportData.members.length -1 ){
                            if(isOffenderExist){
                                plaintiffsMembers= plaintiffsMembers.concat('<hr/>')
                            }else{
                                members= members.concat('<hr/>')
                            }
                        }
                    });
                }
                if (this.reportData.branchManagerName != null) {
                    branchManagerName = branchManagerName.concat(`<p>- اسم المدير  : ${this.reportData.branchManagerName}</p>`);
                }
                if (this.reportData.qualityName != "") {
                    qualityName = qualityName.concat(`  <p>- اسم موظف الجودة  :  ${this.reportData.qualityName} </p> `);
                }
                if (this.reportData.returnNumber != 0) {
                    returnNumber = returnNumber.concat(`<p>- عدد مرات الاعادة للموظف:${this.reportData.returnNumber}</p> `);
                }
                if (this.reportData.daysNumber != 0) {
                    daysNumber = daysNumber.concat(`<p>- المدة بالايام :${this.reportData.daysNumber}</p>`);
                }
                if (this.reportData.criminalPersonName != null) {
                    criminalPersonName = criminalPersonName.concat(` <p >- اسم عضو الضبط الجنائي: ${this.reportData.criminalPersonName} </p> `);
                }
                if (this.reportData.employeeSign != null) {
                    employeeSign = employeeSign.concat(` 
                    <p>التوقيع:</p> 
                    <img style='width:200px;height:50px' src='data:image/png;base64,${this.reportData.employeeSign}'/>
                    <p style="font-size: 20px;float:left"> طبع بواسطة : ${fullName}   ${currentDateTime} </p>
                    
                    `);
                }

                let legalArticles = '';
               
                this.reportData.legalArticles.map((legalArticle) => {
                    legalArticles = legalArticles.concat(`<p > - ${this.convertNumerals(legalArticle.legalArticleTitle)}</p>`);
                });
                if (legalArticles != '')
                    legalArticles = "<p>النصوص النظامية </p>" + legalArticles;


                const body = `
                <div style=" width: 100%;padding-bottom: 60px">
                <div style="display:inline-block;
                float:right; margin: 0 auto;  width:200px">
                <a  class="logo" routerLink='/'>
                <img style="width:50%;margin-left:auto" class="img-fluid for-light" src="../../../../../assets/images/mclogo.png" alt="looginpage">
                </a> 
                </div>
                <div  style=" display:inline-block;
                float:left;
                width:200px;>
                <a  class="logo" routerLink='/'>
                <img style="width:60%" class="img-fluid for-light" src="../../../../../assets/images/Vision2030.png" alt="looginpage">
                </a> 
                </div>
                </div>
         <div style="display:flex;flex-direction:column;align-items: center; justify-content:center">
                    <h5> التقرير الجنائي بمخالفة نظام الشركات (متابعة) </h5>
                </div>     
                <p>الرقم الجنائي :<span> ${criminalNumber}</span> </p>
                <p></p>
                <p >أولاً: الموضوع:
                 تقرير عن مخالفة ${this.convertNumerals(this.reportData.caseNumber)} بشركة ${this.reportData.company.name}  المقيدة بالسجل التجاري برقم ${this.convertNumerals(this.reportData.company.crnumber)}، لأحكام نظام الشركات.
                  ${this.reportData.subject ? this.reportData.subject : ''}</p>
                <hr/>
                
                ${report ? report : '<p >ثانياً: الوقائع: </p>'}
                ${actionTaken ? actionTaken : '<p style="padding-right: 79px;"> - بناء على ذلك تـم  </p>'}
                ${record ? record : '<p style="padding-right: 79px;">- تم سماع أقوال المشتبه بهم بتاريخ </p>'}
                ${reportNotes ? reportNotes : '<p > ثالثاً: الدراسة: </p>'}
                ${legalArticles}
                ${violations ? `<p >المخالفات: الاشتباه بمخالفة المدعى عليه/عليهم لنظام الشركات، </p> ${violations}` : '<p >المخالفات: </p>'}
                ${members ? `<p >- المدعي عليهم :</p> ${members}` : (isOffenderExist ? '<p >- المدعي عليهم :</p>' : '<p >- المدعي عليهم :</p> <hr/>' )}
                ${plaintiffsMembers ? `<p >- المدعي :</p> ${plaintiffsMembers}` : '<p >- المدعي :</p> </hr>'}
                
                ${evidences ? evidences : '<p >رابعاً: الأدلة والقرائن:</p></hr>'}
                ${criminalPersonName ? criminalPersonName : '<p >- اسم عضو الضبط الجنائي:</p>'}
                ${employeeSign ? employeeSign : `<p>التوقيع:</p> <p style="font-size: 20px;float:left"> طبع بواسطة : ${fullName}   ${currentDateTime} </p>`}
                `;
                // @media print {@page{ margin: .75in .5in;  }}
                let contents = `
                    <html>
                        <head>
                            <style  type="text/css">
                                @media print {
                                    @page { margin: 0; }
                                    body { margin: 1.0cm; }
                                }
                                @font-face {
                                    font-family: "Noto Naskh Arabic";
                                    src: url("../../../../../assets/fonts/Noto_Naskh_Arabic/NotoNaskhArabic-VariableFont_wght.ttf") format("truetype");
                                }
                                body,p,td,th,span,div{  font-family: "AL-Mohanad"; font-size:28px;  }
                                h1,h3,h6,h4,h5{  font-family: "AL-Mohanad";   }
                            </style>
                        </head>
                        <body dir="rtl" style="
                        border: 1px solid;
                        padding: 5px;font-family: "AL-Mohanad";
                        border-style: solid; border-width: medium;"> ${body}</body>
                    </html>`;

                let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
                mywindow!.document.open();
                let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                mywindow!.document.write(contents);

                if (is_chrome) {
                    setTimeout(function () {
                        mywindow!.document.close();
                        mywindow!.focus();
                        mywindow!.print();
                        // mywindow.close();
                    }, 1000);
                } else {
                    mywindow!.document.close();
                    mywindow!.focus();
                    mywindow!.print();
                   
                }


          

            });
        } else {
            //تقرير جنائي عادي 
            this.sharedService.get(`api/Case/GetCriminalReport?CaseId=${caseId}`).subscribe(result => {
                this.reportData = result;
                let violations = '';
                let evidences = '';
                let criminalNumber = '';
                let report = '';
                let record = '';
                let actionTaken = '';
                let reportNotes = '';
                let criminalPersonName = '';
                let branchManagerName = '';
                let qualityName = '';
                let daysNumber = '';
                let returnNumber = '';
                let employeeSign = '';
                let members = '';
                let plaintiffsMembers ='';

                let fullName = this.sharedService.CurrentUser.fullName;
                let currentDateTime = moment((new Date)).format('DD/MM/YYYY - h:mm');
                this.ecaseid = this.caseService.case.eCaseId;

                this.reportData.violations.map((el,) => {
                    violations = violations.concat(`<p> - ${this.convertNumerals( el.mainViolationTypeName)}</p>`);
                });
                if (this.reportData.evidencesText != '') {
                    evidences = evidences.concat(`<p >رابعاً: الادلة والقرائن: </p>`)
                    if (this.reportData.evidencesText == null) {
                        evidences = evidences + '';
                    }
                    else evidences = evidences + `<p style="padding-right: 79px;">${this.convertNumerals(this.reportData.evidencesText)}</p> <hr/>`;
                }
                //this.reportData.evidences.map((el) => {
                //    evidences = evidences.concat(`
                //    <p> - ${el.evidenceTitle}</p>`);
                //});
                if (this.reportData.criminalNumber == null) {
                    let getUrl = `api/Case/CreateOrEditCriminalNumber?IsAuto=true&eCaseId=${this.ecaseid}`;
                    this.sharedService.get(getUrl).subscribe((res) => {
                        criminalNumber = criminalNumber.concat(`${this.convertNumerals(res.message)}`);
                    });
                }
                if (this.reportData.criminalNumber != null) {
                    criminalNumber = criminalNumber.concat(`${this.convertNumerals(this.reportData.criminalNumber)}`);
                }
                if (this.reportData.callRecords != null) {
                    this.reportData.callRecords.map((el, i) => {

                        if (el.person != null && el.personName!=null) {
                            record = record.concat(` <p>- تم سماع أقوال  ${el.personName}  هوية وطنية/الإقامة رقم ${this.convertNumerals(el.person.nationIdOrIqama)}بتاريخ ${this.convertNumerals(this.transformToDateOnly(el.createdOn))}</p> `);
                            if (i === this.reportData.callRecords.length - 1) {
                                record = record.concat(`<hr/>`)
                            }
                        }
                       
                    });
                }
                if (this.reportData.actionTaken != null) {
                    actionTaken = actionTaken.concat(`
                    <p >ثالثاً: الدراسة:  </p>
                    <p style="padding-right: 79px;"> - بدراسـة البلاغ ومـا تضمنتـه الأدلـة المقدمة والإجـراءات المتخذة يتضـح الآتي: </p>
                    <p style="padding-right: 79px;"> -${this.convertNumerals(this.reportData.actionTaken)}</p>
                    <hr/>
                    `);
                }
                if (this.reportData.reportNotes != null) {
                    reportNotes = reportNotes.concat(`
                    <p >رأي عضو الضبط الجنائي:</p>
                        ${this.reportData.lakeOfDataName ? this.reportData.lakeOfDataName : ' '}
                        <p style="padding-right: 79px;">${this.convertNumerals(this.reportData.reportNotes)}</p>
                    `);
                    if (this.reportData.penalities != null) {
                        this.reportData.penalities.map((el ,i)=> {
                            reportNotes = reportNotes + '<p >' + el.companyPenaltyTypeName + "</p>";
                            if(i === this.reportData.penalities - 1 ){
                                reportNotes = reportNotes.concat(`<hr/>`)
                            }
                        });
                    }
                }
                this.reportData.reports.map((el,i) => {
                    if (el.reportNumber == null && el.reporterNationalId == null && el.reporterName == null && el.reporterRelationName == "") {
                        report = report.concat(`
                        <p >ثانياً: الوقائع: </p>
                        <p style="padding-right: 79px;">- ورد إلى الوزارة بلاغ  برقم  --- وتاريخ ( ${this.convertNumerals(this.transformToDateOnly(el.reportDate))} )   والمقدم من:---- </p>
                            <p style="padding-right: 79px;"> هوية وطنية/الإقامة رقم----بصفته  ---- </p>
                            <p style="padding-right: 79px;">- وتضمن البلاغ النقاط الآتية: </p>
                            <p style="padding-right: 79px;"> ${el.reportDetails}</p>
                        `);
                        if(i === this.reportData.reports - 1 ){
                            report = report.concat(`<hr/>`)
                        }
                    }
                    if (el.reportNumber != null && el.reporterNationalId != null && el.reporterName != null) {
                        report = report.concat(`
                        <p >ثانياً: الوقائع: </p>
                        <p style="padding-right: 79px;">- ورد إلى الوزارة بلاغ برقم  ${this.convertNumerals(el.reportNumber)}وتاريخ ( ${this.convertNumerals(this.transformToDateOnly(el.reportDate))} )   والمقدم من:${el.reporterName} </p>
                            <p style="padding-right: 79px;"> هوية وطنية/الإقامة رقم${this.convertNumerals(el.reporterNationalId)}بصفته  ${el.reporterRelationName} </p>
                            <p style="padding-right: 79px;">- وتضمن البلاغ النقاط الآتية: </p>
                            <p style="padding-right: 79px;"> ${el.reportDetails}</p>
                        
                        `);
                        if(i === this.reportData.reports - 1 ){
                            report = report.concat(`<hr/>`)
                        }
                    }
                });
                let isOffenderExist=false;
                if (this.reportData.members != null) {
                    this.reportData.members.map((el,i) => {
                        if (el.memberTypeId && el.memberTypeId == 5) {

                            members = members.concat(`
                            <p style="padding-right: 79px;"> - هوية وطنية/الإقامة رقم ${this.convertNumerals(el.nationIdOrIqama)}  ${el.name} بصفته ${el.memberTypeName}</p>
                            `);
                        }
                        if (el.memberTypeId && el.memberTypeId == 6) {
                            isOffenderExist=true;
                            plaintiffsMembers = plaintiffsMembers.concat(`
                            <p style="padding-right: 79px;"> - هوية وطنية/الإقامة رقم ${this.convertNumerals(el.nationIdOrIqama)}  ${el.name} بصفته ${el.memberTypeName}</p>
                            `);
                        }
                        if(i=== this.reportData.members.length -1 ){
                            if(isOffenderExist){
                                plaintiffsMembers= plaintiffsMembers.concat('<hr/>')
                            }else{
                                members= members.concat('<hr/>')
                            }
                        }

                    });
                }
                if (this.reportData.branchManagerName != null) {
                    branchManagerName = branchManagerName.concat(`<p>- اسم المدير  :${this.reportData.branchManagerName}</p>`);
                }
                if (this.reportData.qualityName != "") {
                    qualityName = qualityName.concat(`<p>- اسم موظف الجودة  :${this.reportData.qualityName}</p>`);
                }
                if (this.reportData.returnNumber != 0) {
                    returnNumber = returnNumber.concat(`<p>- عدد مرات الاعادة للموظف:${this.reportData.returnNumber}</p>`);
                }
                if (this.reportData.daysNumber != 0) {
                    daysNumber = daysNumber.concat(`<p>- المدة بالايام :${this.reportData.daysNumber}</p>`);
                }
                if (this.reportData.criminalPersonName != null) {
                    criminalPersonName = criminalPersonName.concat(`<p >- اسم عضو الضبط الجنائي: ${this.reportData.criminalPersonName} </p> `);
                }
                if (this.reportData.employeeSign != null) {
                    employeeSign = employeeSign.concat(`
                        <p>التوقيع:</p> 
                        <img style='width:200px;height:50px' src='data:image/png;base64,${this.reportData.employeeSign}'/>
                        <p style="font-size: 20px;float:left"> طبع بواسطة : ${fullName}   ${currentDateTime} </p>
                        `);
                }
                let legalArticles = '';
                this.reportData.legalArticles.map((legalArticle) => {
                    legalArticles = legalArticles.concat(`<p > - ${this.convertNumerals(legalArticle.legalArticleTitle)}</p>`);
                });
                legalArticles = "<p>النصوص النظامية </p>" + legalArticles;


                const body = `
                <div style=" width: 100%;padding-bottom: 60px">
            <div style="display:inline-block;
            float:right; margin: 0 auto;  width:200px">
            <a  class="logo" routerLink='/'>
            <img style="width:50%;margin-left:auto" class="img-fluid for-light" src="../../../../../assets/images/mclogo.png" alt="looginpage">
            </a> 
            </div>
            <div  style=" display:inline-block;
            float:left;
            width:200px;>
            <a  class="logo" routerLink='/'>
            <img style="width:60%" class="img-fluid for-light" src="../../../../../assets/images/Vision2030.png" alt="looginpage">
            </a> 
            </div>
            </div>
             
                 <div style="display:flex;flex-direction:column;align-items: center; justify-content:center">
                        <h5>التقرير الجنائي بمخالفة نظام الشركات</h5>
                    </div>     
                    <p>الرقم الجنائي :<span> ${criminalNumber}</span> </p>
                    <p></p>
                    <p >أولاً: الموضوع: 
                     تقرير عن مخالفة ${this.convertNumerals(this.reportData.caseNumber)} بشركة ${this.reportData.company.name}  المقيدة بالسجل التجاري برقم ${this.convertNumerals(this.reportData.company.crnumber)}، لأحكام نظام الشركات.
                      ${this.reportData.subject ? this.reportData.subject : ''}</p>
                    <hr/>
                    ${report ? report : '<p >ثانياً: الوقائع: </p> </hr>'}
                    ${members ? `<p >- المدعي عليهم :</p> ${members}`  : (isOffenderExist ? '<p >- المدعي عليهم :</p>' : '<p >- المدعي عليهم :</p> <hr/>' )}
                    ${plaintiffsMembers ? `<p >- المدعي :</p> ${plaintiffsMembers}` : '<p >- المدعي :</p> </hr>'}
                    
                    ${record ? record : ''}
                    ${actionTaken ? actionTaken : '<p >ثالثاً: الدراسة:</p> </hr>'}
                    ${violations ? `<p >المخالفات: الاشتباه بمخالفة المدعى عليه/عليهم لنظام الشركات، </p> ${violations}` : '<p >المخالفات: </p>'}
                 
                    ${legalArticles}
                    ${evidences ? evidences : '<p >رابعاً: الأدلة والقرائن:</p> <hr/>'}
                    ${reportNotes ? reportNotes : '<p >رأي عضو الضبط الجنائي:</p>'}
             
                    ${criminalPersonName ? criminalPersonName : '<p>- اسم عضو الضبط الجنائي:</p>'}
                    ${employeeSign ? employeeSign : `<p>التوقيع:</p> <p style="font-size: 20px;float:left"> طبع بواسطة : ${fullName}   ${currentDateTime} </p>`}
                `;
                // @media print {@page{ margin: .75in .5in;  }}
                let contents = `
                    <html>
                        <head>
                            <style  type="text/css">
                                @media print {
                                    @page { margin: 0; }
                                    body { margin: 1.0cm; }
                                }
                                @font-face {
                                    font-family: "Noto Naskh Arabic";
                                    src: url("../../../../../assets/fonts/Noto_Naskh_Arabic/NotoNaskhArabic-VariableFont_wght.ttf") format("truetype");
                                }
                                body,p,td,th,span,div{  font-family: "AL-Mohanad"; font-size:28px;  }
                                
                                h1,h3,h6,h4,h5{  font-family: "AL-Mohanad";   }
                            </style>
                        </head>
                        <body dir="rtl" style="
                        border: 1px solid;
                        padding: 5px;
                        font-family: "AL-Mohanad";
                        border-style: solid; border-width: medium;"> ${body}</body>
                    </html>
                `;

                let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
                mywindow!.document.open();
                let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                mywindow!.document.write(contents);

                if (is_chrome) {
                    setTimeout(function () {
                        mywindow!.document.close();
                        mywindow!.focus();
                        mywindow!.print();
                        // mywindow.close();
                    }, 1000);
                } else {
                    mywindow!.document.close();
                    mywindow!.focus();
                    mywindow!.print();
                    // mywindow.close();
                }
                // })
            });
        }
          //${ branchManagerName ? branchManagerName : '' }
          //      ${ qualityName ? qualityName : '' }
          //      ${ returnNumber ? returnNumber : '' }
          //      ${ daysNumber ? daysNumber : '' }
    }
}
